module.exports = __webpack_public_path__ + "img/arw-anchor.4c3ba2e5.svg";